<template>
  <div
    class="rb-dropdown"
    :class="[$attrs.class, alignClass]"
    v-bind="$attrs"
    ref="dropdown"
    @click.self="hideDropdown"
  >
    <!-- Trigger -->
    <div @click.stop="toggleDropdown" style="cursor: pointer;">
      <slot name="trigger" />
    </div>

    <!-- Dropdown Menu -->
    <transition name="slide-fade">
      <div
        v-if="computedOpen"
        class="rb-dropdown-menu"
        :style="menuStyle"
      >
        <slot name="content" />
      </div>
    </transition>
  </div>
</template>

<script>
import { DropdownBus } from '@/utils/DropdownBus'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'CustomDropdown',
  inheritAttrs: false,
  props: {
    value: {
      type: Boolean,
      default: false
    },
    minWidth: {
      type: [String, Number],
      default: null
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: 'left', // 'left' | 'right' | 'center'
      validator: val => ['left', 'right', 'center'].includes(val)
    }
  },
  data() {
    return {
      isOpen: false,
      uniqueId: Math.random().toString(36).substr(2, 9)
    }
  },
  computed: {
    ...mapGetters(['activeDropdownId']),
    computedOpen: {
      get() {
        return this.value !== undefined ? this.value : this.isOpen
      },
      set(val) {
        if (this.value !== undefined) {
          this.$emit('input', val)
        } else {
          this.isOpen = val
        }
        this.$emit(val ? 'open' : 'close')
      }
    },
    menuStyle() {
      let styles = {}

      if (this.fullWidth) {
        styles.width = '100%'
        return styles;
      }
      if (this.minWidth) {
        styles.minWidth = typeof this.minWidth === 'number'
          ? `${this.minWidth}px`
          : this.minWidth
      }

      return styles
    },
    alignClass() {
      return {
        'align-left': this.align === 'left',
        'align-right': this.align === 'right',
        'align-center': this.align === 'center'
      }
    }
  },
  watch: {
    activeDropdownId(newVal) {
      if (newVal !== this.uniqueId && this.computedOpen) {
        this.hideDropdown()
      }
    }
  },
  methods: {
    ...mapMutations(['setActiveDropdown','clearActiveDropdown']),
    toggleDropdown() {
      if (!this.computedOpen) {
        this.setActiveDropdown(this.uniqueId);
      } else {
        this.clearActiveDropdown()
      }
      this.computedOpen = !this.computedOpen
    },
    hideDropdown() {
      if (this.computedOpen) {
        this.computedOpen = false
        setTimeout(() => {
          if(this.activeDropdownId === this.uniqueId){
            this.clearActiveDropdown()
          }
        }, 50);
        
      }
    },
    handleClickOutside(e) {
      if (!this.$el.contains(e.target)) {
        this.hideDropdown()
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>

<style scoped>
.rb-dropdown {
  position: relative;
}

.rb-dropdown-menu {
  position: absolute;
  top: 100%;
  margin-top: 0.25rem;
  z-index: 1000;
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.05);
}

/* Alignment class */
.align-left .rb-dropdown-menu {
  left: 0;
}
.align-right .rb-dropdown-menu {
  right: 0;
}
.align-center .rb-dropdown-menu {
  left: 50%;
  transform: translateX(-50%);
}

/* Animation */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.2s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}
</style>



// WEBPACK FOOTER //
// src/components/general/CustomDropdown.vue